<script>
  import { createEventDispatcher, onMount } from 'svelte';


  const dispatch = createEventDispatcher();

  import isEmpty from 'lodash/isEmpty';
  import Button, { options as buttonsOptions } from '@ctm/ui/Button';
  import { Back } from '@ctm/ui/Icons';
  import ActionBar from '../ActionBar/ActionBar.svelte';
  import FlightSearch from './_flightSearch.svelte';
  import FlexSpinner from '../FlexSpinner/FlexSpinner.svelte';
  import ItineraryCard from '../ManageBookings/_ItineraryCard.svelte';
  import { filterSectorsForChange, getItineraryWithSearchChanges } from '../../util/itinerary';
  import { newSearch } from '../../http/itinerary';
  import { getItineraryByPNR } from '../../http/itineraries';
  import cardIn from '../../transitions/cardIn';
  import { hasManageBookingsItinerary, track, trackingEvents, manageBookingsItinerary } from '../../store/index.js';

  let itinerary;
  export let isSearching = false;
  export let isWaiting = true;
  export let pnr;

  export let sectorsForChange = [];

  export let hasChanges;
  $: {
    hasChanges = sectorsForChange.some((sector) => {
      return !isEmpty(sector.change);
    });
  }

  function getItinerary() {
    const manageBookingsItinerary = hasManageBookingsItinerary(pnr);

    if (manageBookingsItinerary) {
      setItinerary(manageBookingsItinerary);
      isWaiting = false;
    } else {
      getItineraryByPNR(pnr)
        .then((response) => {
          setItinerary(response.data);
        })
        .catch(() => {

        })
        .finally(() => {
          isWaiting = false;
        });
    }
  }

  function setItinerary(itineraryToSet) {
    itinerary = { ...itineraryToSet };
    sectorsForChange = filterSectorsForChange(itinerary.Passengers[0]);
  }

  function onBackClick() {
    window.location.hash = `/manage-bookings/${pnr}`;
    track(trackingEvents.CHANGE_BOOKING_BACK_CLICKED);
  }

  function onSearchClick() {
    const searchWithChanges = getItineraryWithSearchChanges(itinerary, sectorsForChange);
    makeChange(searchWithChanges);
  }

  function makeChange(itinerary) {
    isSearching = true;

    newSearch(itinerary)
      .then((response) => {
        const updatedItinerary = response.data;
        $manageBookingsItinerary = null;
        dispatch('changeSuccess', updatedItinerary);
      })
      .finally(() => {
        isSearching = false;
      });

    track(trackingEvents.CHANGE_BOOKING_SEARCH);
  }

  onMount(() => {
    getItinerary();
  });
</script>

<div class="changeBooking">
  <ActionBar>
    <div class="actionBar_back">
      <Button on:click="{onBackClick}" Icon="{Back}" type="link"></Button>
    </div>

    <div class="header_button">
      <Button on:click="{onSearchClick}" isDisabled="{!hasChanges}" isWide isWaiting="{isSearching}">
        Search
      </Button>
    </div>
  </ActionBar>

  <div class="intro">
    <div class="intro_content">
      <h3>Change flights</h3>

      <p>
        Select the flights you would like to change and enter in the new dates and times you'd like to search for, you
        can do this for all eligible flights. Some flights are unable to be changed online and will require you contact
        your dedicated travel consultant.
      </p>

      <p>
        A change fee may be charged by the airline, please check the fare rules for a comprehensive breakdown on any
        applicable fees. Additional baggage and paid seats may be non-refundable or unavailable on the new flight.
      </p>
    </div>
  </div>

  <div class="results">
    { #if isWaiting }
    <FlexSpinner></FlexSpinner>
    { :else }
    { #if sectorsForChange.length }
    <div class="sectors">
      {#each sectorsForChange as sector, s }
      <div class="sectors_item" in:cardIn="{{delay: s * 50}}">
        <ItineraryCard
          bind:change="{ sector.change }"
          sector="{ sector.data }"
          sectorType="{ sector.sectorType }"
          updateSearchComponent="{ FlightSearch }"
        >
        </ItineraryCard>
      </div>
      {/each}
    </div>
    { :else }
    <div class="noSectors">
      <strong>Sorry, looks like something went wrong.</strong><br />
      Please check the URL and try refreshing the page. If you continue to have issues contact your dedicated CTM consultant.
    </div>
    { /if }
    { /if }
  </div>
</div>

<style>
  .changeBooking {
    background: #f3f6fc;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    position: relative;
    overflow: hidden;
    padding-top: 128px;
  }

  .actionBar_back {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 16px;
    top: 15px;
  }

  .intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    color: #3F4F5F;
    font-size: 14px;
    padding: 48px 20px;
    width: 100%;
  }

  .intro h3 {
    color: #2C3E50;
    font-size: 21px;
    font-weight: bold;
    margin: 0 0 16px 0;
  }

  .intro p {
    margin: 0 0 14px 0;
  }

  .intro p:last-child {
    margin-bottom: 0;
  }

  .intro_content {
    width: 100%;
    max-width: 1254px;
  }

  .results {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
  }

  .sectors {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    width: 100%;
    max-width: 1254px;
  }

  .sectors_item {
    width: 100%;
  }

  .sectors_item:not(:last-child) {
    margin-bottom: 19px;
  }

  .noSectors {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 100%;
    max-width: 1254px;
    color: #3f4f5f;
    font-size: 14px;
  }

  @media (min-width: 1025px) {
    .results {
      padding: 0 20px;
    }

    .sectors {
      padding: 111px 0;
    }
  }
</style>
